import {BaseFactory} from "../../../infrastructure/factories/base-factory";
import {EntityDescriptionResponseApiModel} from "../models/entity-description.response-api-model";
import {EntityDescriptionDataSource} from "../models/entity-description.data-source";
import {EntityDescriptionSectionDomainModel} from "../models/section/entity-description.section.domain-model";
import type {EntityDescriptionSectionApiModel} from "../models/section/entity-description.section.api-model";

export class EntityDescriptionFactory extends BaseFactory {
  createResponse(apiModel: EntityDescriptionResponseApiModel, request) {
    const responseApiModel: EntityDescriptionResponseApiModel = new EntityDescriptionResponseApiModel(apiModel, request);

    return responseApiModel;
  }

  createDomainModel(response: EntityDescriptionResponseApiModel): EntityDescriptionDataSource {
    const sections: EntityDescriptionSectionDomainModel = response.sections?.map((section: EntityDescriptionSectionApiModel) => new EntityDescriptionSectionDomainModel(section));
    const dataSource: EntityDescriptionDataSource = new EntityDescriptionDataSource(response, sections)

    return dataSource;
  }
}
